// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RelatedPapersSidebar-cls1___fb0cb2de32bc75297f7{/*!*/}.RelatedPapersSidebar-cls2__fc789fb36e17ced37451{color:#223;color:var(--text-primary, #223)}.RelatedPapersSidebar-cls2__fc789fb36e17ced37451:hover,.RelatedPapersSidebar-cls2__fc789fb36e17ced37451:active,.RelatedPapersSidebar-cls2__fc789fb36e17ced37451:focus{color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RelatedPapersSidebar-cls1___fb0cb2de32bc75297f7",
	"cls2": "RelatedPapersSidebar-cls2__fc789fb36e17ced37451 RelatedPapersSidebar-cls1___fb0cb2de32bc75297f7"
};
export default ___CSS_LOADER_EXPORT___;
